import { Fragment, createRef, useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllData, getTableColumns } from "../../services/Servicos";
import { updateTransportadorasList } from "../../redux/slicers/user";
import ScrollbarLeft from "../scrollbars/ScrollbarLeft";
import HeadTable from "../table/head/HeadRow";
import {
  filtroDinamicoArrays,
  removerDadosDuplicados,
} from "../../services/helpers";
import ModalCriarTransportadora from "./ModalCriarTransportadora";
import BodyRowTransportadora from "../table/body/BodyRowTransportadora";

import "./Modal.scss";

const tableRef = createRef();
const tbodyRef = createRef();

export default function ModalTransportadoras(props) {
  const dispatch = useDispatch();
  const transportadora = useSelector(
    (state) => state.userSlice.transportadorasList || { data: [] }
  );
  const user = useSelector((state) => state.userSlice);

  const [loading, setLoading] = useState(true);
  const [indexList, setIndexList] = useState(10);
  const [filteredTable, setFilteredTable] = useState(false);
  const [filters, setFilters] = useState([]);
  const [lancarModal, setLancarModal] = useState({
    flag: false,
  });
  const [editarTransportadora, setEditarTransportadora] = useState({
    flag: false,
  });
  const [headList, setHead] = useState([
    "index",
    "admin",
    "razao_social",
    "nome_fantasia",
    "cnpj",
    "inscricao_estadual",
    "endereco",
    "email",
    "telefone",
    "rntrc",
  ]);
  const [filtersNew, setFiltersNew] = useState({});

  const handlerSimpleClose = () =>
    props.setShow((last) => ({ ...last, flag: false }));

  useEffect(() => {
    if (!filters.length) {
      setIndexList(10);
      setFilteredTable(false);
      return;
    }

    let testeFilters = {};

    filters.forEach((ele) => {
      const param = Object.getOwnPropertyNames(ele)[0];
      testeFilters[param] = [];
    });

    filters.forEach((ele) => {
      const param = Object.getOwnPropertyNames(ele)[0];
      testeFilters[param].push(String(ele[param]).toLowerCase());

      if (String(ele[param]).toLowerCase() == "false") {
        testeFilters[param].push("null");
      }
    });

    let arrayRetorno = [transportadora.data || []];

    Object.keys(testeFilters).forEach((key, index) => {
      arrayRetorno.push(
        filtroDinamicoArrays(
          testeFilters,
          key,
          arrayRetorno[arrayRetorno.length - 1]
        )
      );
    });

    const arrayF = removerDadosDuplicados(
      arrayRetorno[arrayRetorno.length - 1],
      "id"
    );
    setFilteredTable(arrayF.reverse());
  }, [filters, transportadora]);

  useEffect(() => {
    const refTable = tableRef.current;
    if (!refTable) return;

    const scrollHandler = (e) => {
      const tbodyHeight = tbodyRef.current.clientHeight;
      const divTableHeight = e.target.clientHeight;
      const scrollPosition = e.target.scrollTop;
      if (scrollPosition >= tbodyHeight - divTableHeight) {
        setTimeout(() => {
          setIndexList(indexList + 10);
        }, 1000);
      }
    };

    refTable.addEventListener("scroll", scrollHandler, false);

    return () => refTable.removeEventListener("scroll", scrollHandler, false);
  }, [indexList]);

  const onClickRemoveFilter = (e) => {
    e.preventDefault();
    const value = e.target.parentNode.firstElementChild.innerText;
    const [key, keyValue] = value.split(":");
    setFilters((last) => [
      ...last.filter(
        (item) =>
          String(item[key]).replaceAll(" ", "") !== keyValue.replaceAll(" ", "")
      ),
    ]);
  };

  const updateArray = async () => {
    try {
      getAllData("transportadoras")
        .then((response) => {
          dispatch(updateTransportadorasList(response.data));
        })
        .catch((err) => {
          // If endpoint doesn't exist, initialize with empty data
          dispatch(updateTransportadorasList([]));
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching transportadoras:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    updateArray();
  }, []);

  return (
    <>
      <Modal
        show={props.show}
        onHide={handlerSimpleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Fragment>
            <div className="section-filters-table mb-3">
              <div className="card-header">
                <h5>Filtros Selecionados</h5>
              </div>
              <Row className="mt-2 row-filters">
                <Col>
                  <div>
                    {filters.map((item, key) =>
                      Object.keys(item).map((key, index) => {
                        return (
                          <span className="filters-card" key={index}>
                            <span className="filters">
                              <span className="title">
                                {key}: {item[key]}
                              </span>
                              <i
                                className="bi bi-x-lg"
                                onClick={onClickRemoveFilter}
                              ></i>
                            </span>
                          </span>
                        );
                      })
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            <div className="section-filters-table">
              <div className="card-header pb-2">
                <Row className="justify-content-between">
                  <Col sm="12" md="6" lg="8">
                    <h5 style={{ display: "flex", alignItems: "center" }}>
                      Tabela de Transportadoras{" "}
                      {loading ? (
                        <Spinner
                          style={{ marginLeft: "10px", fontSize: "1rem" }}
                          animation="border"
                          size="sm"
                        />
                      ) : (
                        ""
                      )}
                    </h5>
                  </Col>
                  <Col sm="12" md="6" lg="2">
                    <Button
                      variant="primary"
                      onClick={() => setLancarModal({ flag: true })}
                      size="sm"
                    >
                      +Adicionar Transportadora
                    </Button>
                  </Col>
                </Row>
              </div>
              <div
                className="responsive-table"
                ref={tableRef}
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                <ScrollbarLeft
                  tableRef={tableRef}
                  coluna2={3}
                  maxima_distancia={180}
                />
                <Table hover size="sm">
                  <thead style={{ zIndex: 49 }}>
                    <HeadTable
                      rota="transportadoras"
                      arrayValues={transportadora.data || []}
                      headerList={headList}
                      setArrayFilters={setFiltersNew}
                      arrayFilters={filtersNew}
                      setFiltersOld={setFilters}
                      filtersOld={filters}
                    />
                  </thead>
                  <tbody ref={tbodyRef}>
                    {filteredTable
                      ? filteredTable.map((item, index, self) => {
                          if (index < indexList) {
                            return (
                              <BodyRowTransportadora
                                key={index}
                                bodyList={item}
                                headList={headList}
                                index={index}
                                setEditarTransportadora={
                                  setEditarTransportadora
                                }
                                tableLength={self.length}
                              />
                            );
                          }
                        })
                      : [...(transportadora.data || [])]
                          .reverse()
                          .map((item, index, self) => {
                            if (index < indexList) {
                              return (
                                <BodyRowTransportadora
                                  key={index}
                                  bodyList={item}
                                  headList={headList}
                                  index={index}
                                  setEditarTransportadora={
                                    setEditarTransportadora
                                  }
                                  tableLength={self.length}
                                />
                              );
                            }
                          })}
                  </tbody>
                </Table>
              </div>
            </div>
          </Fragment>
        </Modal.Body>
      </Modal>

      {lancarModal.flag ? (
        <ModalCriarTransportadora
          show={lancarModal.flag}
          setShow={setLancarModal}
          title={"Cadastrar Nova Transportadora"}
        />
      ) : (
        ""
      )}
    </>
  );
}
